module.exports = __webpack_public_path__ + "img/52.66922f1e.jpg";